/**
 * HelpTooltip - Shows a help icon with tooltip on hover
 *
 * Props:
 *   text - The tooltip text to display
 */
import { FiHelpCircle } from 'react-icons/fi';

interface HelpTooltipProps {
  text: string;
}

const HelpTooltip = ({ text }: HelpTooltipProps) => {
  return (
    <span className="relative inline-flex group ml-1">
      <FiHelpCircle
        size={14}
        className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 cursor-help"
      />
      <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 text-xs text-white bg-gray-900 dark:bg-gray-700 rounded-lg shadow-lg whitespace-normal max-w-xs w-max opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50 pointer-events-none">
        {text}
        <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900 dark:border-t-gray-700" />
      </span>
    </span>
  );
};

export default HelpTooltip;
